const SETBGCOL = "SETBGCOL";
const SETEXAMPLECOL = "SETEXAMPLECOL";
const SETEXAMPLERADIUS = "SETEXAMPLERADIUS";

const SETLIST = "SETLIST";
const CHANGEACTIVEID = "CHANGEACTIVEID";
const ADDBOXSHADOW = "ADDBOXSHADOW";
const REMOVEBOXSHADOW = "REMOVEBOXHADOW";

const SETOFFSETX = "SETOFFSETX";
const SETOFFSETY = "SETOFFSETY";
const SETSPREAD = "SETSPREAD";
const SETBLUR = "SETBLUR";
const SETINSET = "SETINSET";
const SETSHADOWCOLOR = "SETSHADOWCOLOR";

export const actionType = {
  SETBGCOL,
  SETEXAMPLERADIUS,
  SETEXAMPLECOL,
  SETLIST,
  CHANGEACTIVEID,
  ADDBOXSHADOW,
  REMOVEBOXSHADOW,
  SETOFFSETX,
  SETOFFSETY,
  SETSPREAD,
  SETBLUR,
  SETINSET,
  SETSHADOWCOLOR,
};
